/* eslint-disable react/prop-types */
import classes from "./more-infos.module.scss";
import classNames from "classnames";
import ExpandableContainer from "@/components-library/layout/expandable-container";
import ExpandableGroup from "@/components-library/layout/expandable-group";
import Content from "./content";
import Header from "./header";
function MoreInfos({ interventions, facilitation, incentive, className }) {
  return (
    <div className={classNames(classes.container, className)}>
      <ExpandableContainer
        header={
          <Header label="Maggiori informazioni" className={classes.header} />
        }
        className={classes.container}
      >
        <ExpandableGroup singleOpen={true}>
          <Content
            interventions={interventions}
            facilitation={facilitation}
            incentive={incentive}
          />
        </ExpandableGroup>
      </ExpandableContainer>
    </div>
  );
}

export default MoreInfos;
